import {Component, Inject, LOCALE_ID} from '@angular/core';
import {Router} from "@angular/router";
import {GlobalService} from "../../../services/global.service";
import {ConfigService} from "../../../services/config.service";

@Component({
  selector: 'app-nowruz-soor',
  standalone: true,
  imports: [],
  templateUrl: './nowruz-soor.component.html',
  styleUrl: './nowruz-soor.component.css'
})
export class NowruzSoorComponent {
  constructor(public route: Router,
              @Inject(LOCALE_ID) public locale: string,
              public global: GlobalService,
              public conf: ConfigService) {

  }

}
